import { type AnnotationOptions } from "chartjs-plugin-annotation";

import { makeFont } from "../../../model-fit-chart/utils/annotation-helpers";
import { REVENUE_ID, ROAS_ID } from "../const";

import { xPosition } from "./average-adopted-mix-spend-annotation";

export const medianWeeklySpendAnnotation = ({
  dateRange,
  medianSpendIndex,
  medianSpendValue,
  medianSpendLabelOptions,
}: {
  dateRange: string;
  medianSpendIndex: number;
  medianSpendValue?: string;
  medianSpendLabelOptions?: Record<string, unknown>;
}): Record<string, AnnotationOptions> => ({
  medianSpendLabel: {
    type: "label",
    display: true,
    position: (ctx) => ({
      x: xPosition(ctx, medianSpendIndex),
      y: "start",
    }),
    xValue: medianSpendIndex || 0,
    yValue: (ctx) => {
      const scale =
        ctx.chart.scales?.[REVENUE_ID] || ctx.chart.scales?.[ROAS_ID];
      return scale?.max || 0;
    },
    yAdjust: -4,
    xAdjust: (ctx) => (xPosition(ctx, medianSpendIndex) === "start" ? 4 : -4),
    content: `${
      {
        last_4_weeks: "LAST 4 WEEKS",
        last_5_weeks: "LAST 5 WEEKS",
        last_26_weeks: "LAST 26 WEEKS",
        last_52_weeks: "LAST 52 WEEKS",
        last_year: "LAST YEAR'S",
        all_time: "ALL TIME",
      }[dateRange]
    } MEDIAN HISTORICAL SPEND`,
    font: makeFont(),
    color: "rgb(151,151,151)",
    ...(medianSpendLabelOptions ? { ...medianSpendLabelOptions } : {}),
  },
  medianSpend: {
    type: "label",
    display: !(medianSpendValue === undefined),
    position: (ctx) => ({
      x: xPosition(ctx, medianSpendIndex),
      y: "start",
    }),
    xValue: medianSpendIndex ?? 0,
    yValue: (ctx) => {
      const scale =
        ctx.chart.scales?.[REVENUE_ID] || ctx.chart.scales?.[ROAS_ID];
      return scale?.max || 0;
    },
    yAdjust: 16,
    xAdjust: (ctx) => (xPosition(ctx, medianSpendIndex) === "start" ? 4 : -4),
    content: medianSpendValue === undefined ? "" : medianSpendValue,
    font: makeFont({
      size: 10,
      weight: "normal",
    }),
    color: "rgb(151,151,151)",
  },
  medianRangeLine: {
    borderColor: "#979797",
    borderWidth: 1,
    type: "line",
    xMin: medianSpendIndex,
    xMax: medianSpendIndex,
    yMin: 0,
    yMax: Infinity,
  },
});
